import React, { useContext, useMemo, useState } from 'react';
import moment from 'moment';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { PreferencesContext } from '@common/contexts/preferences';
import { useDataFetch } from '@common/hooks/dataFetch';
import { UIContext } from '@app/dev/contexts/ui';
import ResultTable from './components/table';
import ResultFilters from './components/filters';
import EventTypeFilter from '../../components/eventTypeFilter';
import { configTypeMap } from '../../components/eventTypeFilter/constants';

import './style.scss';

const Results = () => {
  const [{ lang }] = useContext(PreferencesContext);

  const initialFilters = useMemo(() => {
    const today = moment().endOf('day').unix();

    return {
      from_date: today - 86400,
      to_date: today,
      live: 0,
    };
  }, []);

  const [searchText, setSearchText] = useState('');
  const [filters, setFilters] = useState(initialFilters);
  const { from_date, to_date } = filters;
  const [{ theme }] = useContext(UIContext);
  const [activeCompetitions, competitionsLoading] = useDataFetch(
    () => swarmRequest({ from_date, to_date }, 'get_active_competitions'),
    [from_date, to_date, lang],
  );

  return (
    <section className="results-page">
      <ResultFilters
        filters={filters}
        initialFilters={initialFilters}
        onChange={setFilters}
        searchText={searchText}
        activeCompetitions={activeCompetitions}
        onSearchChange={setSearchText}
      />

      {filters.sport_id && (
        <ResultTable
          filters={filters}
          searchText={searchText}
          sportId={filters.sport_id}
          competitionsLoading={competitionsLoading}
        />
      )}
    </section>
  );
};

export default Results;
